<template>
    <div class="mainpage">
        <Dialog v-model:visible="dialogVisible" @update:visible="cancel()" position="center" modal header="Warning" :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
            <p class="m-0">
                Please whitelist {{ registeredDlt }} short domain with your preferred Header to use URL Shortener.
            </p>
        </Dialog>
        <Form @submit="submitShort">
            <div class="input-fields">
                <label class="mb-1" for="static-url">Link name</label>
                <Field name="name" :rules="isRequired" v-model="linkName" v-slot="{ field, errors }">
                    <InputText type="text" v-bind="field" placeholder="Enter the name of link" />
                    <span class="validation-error">{{ errors[0] }}</span>
                </Field>
            </div>
            <div class="input-fields">
                <label class="mb-1" for="static-url">Long URL</label>
                <Dropdown v-model="longurl" filter :options="getTableData" optionLabel="Cta" placeholder="Filter by CTA type" />
            </div>
            <div v-if="longurl && longurl.HasVariable" class="input-fields">
                <label class="mb-1" for="Actual URL">Actual URL</label>
                <Field name="actualUrl" :rules="isRequired" v-model="actualurl" v-slot="{ field, errors }">
                    <InputText type="text" v-bind="field" placeholder="Enter the actual URL" />
                    <span class="validation-error">{{ errors[0] }}</span>
                </Field>
            </div>
            <div class="options">
                <p class="fw-bold">CTA Options</p>
                <div>
                    <div class="d-flex justify-content-start align-items-center mb-4">
                        <div class="d-flex flex-column gap">
                            <label class="mb-1" for="protocol">Protocol</label>
                            <div class="d-flex justify-content-start align-items-center">
                                <InputText type="text" v-model="protocol" placeholder="https" disabled/>
                                <p class="m-0 px-2"> :// </p>
                            </div>
                            <small class="hide-text"></small>
                        </div>
                        <div class="d-flex flex-column gap">
                            <label class="mb-1" for="static-url">Domain</label>
                            <div class="d-flex justify-content-start align-items-center">
                                <InputText type="text" v-model="domain" placeholder="https" disabled/>
                                <p class="m-0 px-2"> / </p>
                            </div>
                            <small class="hide-text"></small>
                        </div>
                        <div class="d-flex flex-column gap">
                            <label class="mb-1" for="static-url">Header</label>
                            <div class="d-flex justify-content-start align-items-center">
                                <Dropdown optionLabel="name" optionValue="name" class="domain-dropdown gap" v-model="identifier" filter :options="getIdentifiers" placeholder="Header"/>
                                <p class="m-0"> / </p>
                            </div>
                            <small class="hide-text"></small>
                        </div>
                        <div class="d-flex flex-column">
                            <label class="mb-1" for="backhalf">Custom Back Half</label>
                            <InputText id="backhalf" type="text" v-model="backHalf" aria-describedby="backhalf-help"/>
                            <small class="hide-text"></small>
                        </div>
                    </div>
                    <div class="content__footer_rules mb-3">
                        <div v-for="(item, idx) in url_shorten_rules" :key="idx">
                            {{ idx + 1 }}. {{ item }}
                        </div>
                    </div>
                    <div class="shortCheck">
                        <Checkbox inputId="allowShort" v-model="allowShort" :binary="true"  disabled/>
                        <label for="allowShort" class="mb-0 mx-2 cursor-pointer"> Allow short url in messages. </label>
                    </div>
                </div>
            </div>
            <div class="actions-btns">
                <div class="gap">
                    <Button label="Submit" type="submit"/>
                </div>
                <div>
                    <Button label="Cancel" severity="secondary" @click="cancel"/>
                </div>
            </div>
        </Form>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { doesUrlhasParams, mapModels } from '@/utils'
import { lengths, protocolOptions } from '@/constants'
import config from '@/config/config'
import Toastr from 'toastr'

export default {
    name: 'NewLink',
    components: {

    },
    data () {
        return {
            dialogVisible: false,
            protocolOptions,
            linkName: '',
            actualurl: '',
            longurl: '',
            domain: config.DEFAULT_DOMAIN,
            backHalf: '',
            allowShort: true,
            protocol: 'https',
            pathLength: 6,
            lengths: lengths,
            allowTracking: false,
            url_shorten_rules: [
                'Use this shortened URL while sending the SMS instead of the long URL',
                'User Tracking is not available for custom back half',
                'The validity of this URL will be 30 days'
            ],
            identifier: ''
        }
    },
    methods: {
        cancel () {
            this.$router.push('/link')
        },
        isRequired (value) {
            if (!value) {
                return 'This is a required field'
            }
            return true
        },
        async submitShort () {
            if (this.longurl === '') {
                Toastr.error('Short Link', 'Long URL is required')
                return
            }

            const data = {
                name: this.linkName,
                long_url: this.longurl.Cta,
                dynamic_url: this.longurl.HasVariable ? this.actualurl : '',
                cta_id: this.longurl.CtaID,
                isDynamic: this.longurl.HasVariable,
                protocol: this.protocol,
                domain: this.domain,
                identifier: this.identifier,
                custom_backhalf: this.backHalf,
                allow_short_url: this.allowShort
            }

            if (data.identifier === '') {
                Toastr.error('Short Link', 'Header is required')
                return
            } else if (data.custom_backhalf.length < 4 || data.custom_backhalf.length > 10) {
                Toastr.error('Short Link', 'Custom backhalf be of length 4 to 10')
                return
            } else if (data.custom_backhalf !== '' && data.custom_backhalf.includes('/')) {
                Toastr.error('Short Link', '\'/\' not allowed in custom backhalf')
                return
            } else if (this.actualurl !== '' && !this.actualurl.startsWith(this.longurl.Cta)) {
                Toastr.error('Short Link', 'Actual URL not starts with Long URL')
                return
            } else if (this.actualurl !== '' && !doesUrlhasParams(this.actualurl)) {
                Toastr.error('Short Link', 'Improper query params at end of sample url')
                return
            }
            this.globalLoader = true
            const resp = await this.$store.dispatch('Links/Link/shortUrl', data)
            if (resp && resp.displayMsg && resp.displayMsg.s) {
                this.$router.push('/link/report?id=' + resp.id)
            }
            this.globalLoader = false
        }
    },
    computed: {
        ...mapGetters({ currentUser: 'currentUser' }),
        ...mapModels('general', ['globalLoader']),
        ...mapGetters('Cta/Whitelist', ['getTableData', 'getIdentifiers']),
        ...mapGetters('Domains/Domain', ['getActiveDomains'])
    },
    async beforeMount () {
        await this.$store.dispatch('Cta/Whitelist/fetchIdentifiers', { shortdomain: 'https://' + config.DEFAULT_DOMAIN, from_db: true })
        if (this.getIdentifiers.length === 0) {
            this.dialogVisible = true
        } else {
            this.dialogVisible = false
        }
    },
    async mounted () {
        this.globalLoader = true
        this.$store.dispatch('Domains/Domain/fetchActiveDomains')
        await this.$store.dispatch('Cta/Whitelist/fetchCtas', { completeList: true, type: 'url', subtype: { value: ['sd'], operator: 'not in' }, status: 1 })
        this.globalLoader = false
    },
    watch: {
        longurl () {
            this.actualurl = ''
        }
    }
}
</script>

<style>
.options {
    margin-bottom: 1rem;
    background-color: white;
    padding: 1rem;
}
.domain-dropdown {
    width: 200px;
}
.hide-text:empty::before {
  content:"";
  display: inline-block;
}
.shortCheck {
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
}
.p-dropdown-panel {
    max-width: 500px;
}
</style>
